export default {
   trust_subtitle: 'Private excursions in Egypt with personal service and English speaking support.',
  contact_cta: 'Request Your Trip',
  // === Top Header ===
  top_whatsapp: 'WhatsApp',
  top_phone: 'Phone',
  top_quick_booking: 'Quick Booking',
  top_currency_eur: 'EUR',
  top_currency_usd: 'USD',
  top_currency_gbp: 'GBP',

  // === Main Navigation ===
  nav_home: 'Home',
  nav_hurghada: 'Hurghada Tours',
  nav_marsa_alam: 'Marsa Alam Tours',
  nav_transfers: 'Transfers',
  nav_about: 'About Us',
  nav_contact: 'Contact',

  // === Hero ===
  hero_headline: 'Experience Egypt Exclusively',
  hero_subheadline: 'Private excursions, transfers and English speaking guides in Hurghada, Marsa Alam, Luxor and Cairo. No deposit required — pay conveniently on site.',
  hero_cta_primary: 'Discover Excursions',
  hero_cta_secondary: 'Inquire via WhatsApp',

  // === Trust Badges ===
  trust_title: 'Why Yallabina Tours?',
  trust_experience: 'Over 10 Years of Experience',
  trust_no_deposit: 'No Deposit Required',
  trust_pay_on_site: 'Pay on Site',
  trust_licensed: 'Licensed Egyptologists',
  trust_english_guides: 'English-Speaking Guides',
  trust_private_cars: 'Private Vehicles',
  trust_transparent: 'Transparent Prices',
  trust_individual: 'Individual Care',
  trust_support: '24/7 WhatsApp Support',
  hurghada_tours_title: 'Hurghada Excursions',
hurghada_tours_subtitle: 'Our most popular private excursions with English-speaking guides.',
marsa_alam_tours_title: 'Marsa Alam Excursions',
marsa_alam_tours_subtitle: 'Private tours and experiences from Marsa Alam with English-speaking guides.',

  // === Trust Section ===
  trust_section_title: 'Why Book with Yallabina Tours?',
  trust_no_deposit_detail: 'No Deposit Required',
  trust_pay_onsite_detail: 'Pay on Site',
  trust_licensed_detail: 'Licensed Tour Guides',
  trust_german_detail: 'English-Speaking Support',
  trust_private_detail: 'Private Transfers',
  trust_transparent_detail: 'Transparent Prices, No Hidden Costs',
  trust_individual_detail: 'Individual Tours Instead of Mass Tourism',
  trust_support_detail: '24/7 WhatsApp Support',

  // === Tours from Hurghada ===
  hurghada_title: 'Excursions from Hurghada',
  hurghada_subtitle: 'Exclusive private excursions with English speaking Egyptologists departing from Hurghada',
  hurghada_badge: 'Hurghada',

  // === Tours from Marsa Alam ===
  marsa_alam_title: 'Excursions from Marsa Alam',
  marsa_alam_subtitle: 'Private tours and experiences from Marsa Alam with personal service',
  marsa_alam_badge: 'Marsa Alam',

  // === Tour Card ===
  tour_from: 'from',
  tour_per_person: 'per person',
  tour_book_now: 'Request Now',
  tour_details: 'Details',
  tour_half_day: 'Half Day',
  tour_full_day: 'Full Day',
  tour_multi_day: 'Multi Day',

  // === Tour Detail ===
  tour_overview: 'Overview',
  tour_highlights: 'Highlights',
  tour_itinerary: 'Itinerary',
  tour_included: 'Included',
  tour_excluded: 'Not Included',
  tour_tips: 'Travel Tips',
  tour_duration: 'Duration',
  tour_meeting_point: 'Hotel Pickup Included',
  tour_languages: 'English-Speaking Guide',
  tour_faq: 'FAQ',
  tour_reviews: 'Guest Reviews',
  tour_gallery: 'Gallery',
  tour_price_table: 'Price Table',
  tour_price_from: 'Price from',
  tour_pickup_included: 'Hotel Pickup Included',
  tour_english_guide: 'English-Speaking Guide',
  tour_booking_form: 'Booking Request',
  tour_select_date: 'Travel Date',
  tour_adults: 'Adults',
  tour_children: 'Children',
  tour_hotel: 'Hotel Name',
  tour_whatsapp: 'WhatsApp Number',
  tour_special_requests: 'Special Requests',
  tour_submit_request: 'Request Without Obligation',
  tour_request_sent: 'Request Sent!',
  tour_request_message: 'We will contact you within 24 hours.',
  tour_no_online_payment: 'No online payment required. You pay directly on site.',
  tour_full_name: 'Full Name',
  tour_email_address: 'Email Address',
  tour_phone_number: 'Phone Number',

  // === Reservation Cart ===
  cart_title: 'Your Booking Requests',
  cart_empty: 'No excursions selected',
  cart_empty_desc: 'Add excursions to submit a booking request.',
  cart_tour: 'Excursion',
  cart_date: 'Date',
  cart_guests: 'Guests',
  cart_hotel: 'Hotel',
  cart_total: 'Total Price',
  cart_customer_info: 'Customer Details',
  cart_name: 'Full Name',
  cart_email: 'Email Address',
  cart_phone: 'Phone Number',
  cart_notes: 'Special Requests',
  cart_send_request: 'Submit Booking Request',
  cart_remove: 'Remove',
  cart_add_more: 'Add More Excursions',
  cart_success_title: 'Thank You!',
  cart_success_message: 'Your booking request has been submitted. We will contact you within 24 hours.',

  // === Transfers ===
  transfers_title: 'Transfers',
  transfers_subtitle: 'Private airport transfers and limousine service throughout the region',
  transfers_airport_hurghada: 'Hurghada Airport',
  transfers_airport_marsa_alam: 'Marsa Alam Airport',
  transfers_hotel: 'Hotel Transfer',
  transfers_limousine: 'Private Limousine',
  transfers_minibus: 'Private Minibus',
  transfers_from: 'From',
  transfers_to: 'To',
  transfers_duration: 'Travel Time',
  transfers_price: 'Price',
  transfers_vehicle: 'Vehicle',
  transfers_book: 'Book Transfer',
  transfers_destinations: 'Transfer Destinations',
  transfers_route_info: 'Route Information',
  transfers_vehicle_types: 'Vehicle Types',

  // === About Us ===
  about_title: 'About Yallabina Tours',
  about_subtitle: 'Your trusted partner for exclusive Egypt experiences',
  about_story: 'Our Story',
  about_story_text: 'Yallabina Tours was founded by a team of licensed Egyptian tour guides and Egyptologists with many years of experience serving German tourists. Our goal is to show you the beauty and history of Egypt in a personal, private, and unforgettable way.',
  about_mission: 'Our Mission',
  about_mission_text: 'We offer customized private excursions with the highest quality, safety, and comfort. Each tour is individually tailored to your wishes — without group stress, without time pressure.',
  about_expertise: 'Local Expertise',
about_expertise_text: 'Our local guides know Egypt inside and out and show you places, stories and experiences that remain hidden to many visitors.',

about_safety: 'Safety & Trust',
about_safety_text: 'Modern vehicles, licensed guides and transparent prices ensure that you can enjoy your journey in a relaxed and safe way.',

about_flexibility: 'Flexibility',
about_flexibility_text: 'Every tour is individually tailored to your wishes – without time pressure, fixed groups or unnecessary restrictions.',

about_personal: 'Personal Service',
about_personal_text: 'From your first message until your return to the hotel, we are personally there for you – fast, reliable and always available.',
  about_stats_tours: 'Excursions',
  about_stats_guests: 'Satisfied Guests',
  about_stats_years: 'Years Experience',
  about_stats_guides: 'Guides & Egyptologists',

  // === Reviews ===
  reviews_title: 'What Our Guests Say',
  reviews_subtitle: 'Experiences from travelers who discovered Egypt with us',
  reviews_verified: 'Verified Review',

    // === Contact ===
  contact_title: 'Contact & Booking',
  contact_subtitle: 'We are here for you – personal, fast and reliable.',
  contact_form_title: 'Your Inquiry',
  contact_name: 'Your Name',
  contact_email: 'Your Email Address',
  contact_phone_label: 'Your Phone Number',
  contact_subject: 'Subject',
  contact_message: 'Your Message',
  contact_send: 'Send Inquiry',
  contact_success: 'Inquiry Sent!',
  contact_success_message: 'Thank you! We will contact you within 24 hours.',
  contact_whatsapp: 'WhatsApp',
  contact_call: 'Call',
  contact_email_us: 'Email',
  contact_location: 'Our Location',
  contact_hours: 'Personal Service',
  contact_hours_text: 'Available for you every day',

  contact_request_type: 'Type of Inquiry',
  contact_excursion: 'Excursion',
  contact_transfer: 'Airport Transfer',
  contact_private_transfer: 'Private Transfer',
  contact_general: 'General Inquiry',
  contact_travel_date: 'Travel Date',
  contact_guests: 'Number of Guests',
  contact_hotel: 'Hotel / Accommodation',
  contact_flight_number: 'Flight Number (optional)',
  contact_special_requests: 'Special Requests',
  contact_select_option: 'Please select',
  contact_whatsapp_booking: 'Inquire via WhatsApp',

  // === Footer ===
  footer_company_desc: 'Yallabina Tours is a licensed Egyptian travel company specializing in private excursions, transfers, and English speaking Egyptologist tours throughout Egypt.',
  footer_quick_links: 'Quick Links',
  footer_services: 'Our Services',
  footer_contact_info: 'Contact',
  footer_legal: 'Legal',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms & Conditions',
  footer_imprint: 'Imprint',
  footer_copyright: '©2026 Yallabina Tours. All rights reserved.',
  footer_newsletter: 'Newsletter',
  footer_newsletter_desc: 'Receive exclusive offers and travel tips.',
  footer_email_placeholder: 'Your email address',
  footer_subscribe: 'Subscribe',
  footer_follow_us: 'Follow Us',
footer_whatsapp_booking: 'Book via WhatsApp',

  // === Common ===
  read_more: 'Read More',
  show_more: 'Show More',
  show_less: 'Show Less',
  loading: 'Loading...',
  error: 'An error occurred',
  retry: 'Retry',
  search: 'Search',
  language: 'Language',
  currency: 'Currency',
  days: 'Days',
  hours: 'Hours',
  minutes: 'Minutes',
  back: 'Back',
  submit: 'Submit',
  cancel: 'Cancel',
  close: 'Close',
  
};